import { createFileRoute } from "@tanstack/react-router";
import { siteTitle, siteUrl } from "@/config/site";
import { SignUpPage } from "@/components/auth/sign-up-page";
import { headMessage } from "@/lib/i18n";

type SignUpSearch = { next?: string };

export const Route = createFileRoute("/($locale)/auth/sign-up")({
  validateSearch: (search: Record<string, unknown>): SignUpSearch => ({
    next: typeof search.next === "string" ? search.next : undefined,
  }),
  head: ({ matches }) => {
    const canonicalUrl = `${siteUrl}/auth/sign-up`;
    return {
      meta: [
        { title: `${headMessage(matches, "auth.signUp.metaTitle")} | ${siteTitle}` },
        { name: "description", content: headMessage(matches, "auth.signUp.metaDescription") },
        { name: "robots", content: "noindex,follow" },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: function SignUpRoute() {
    const { next } = Route.useSearch();
    return <SignUpPage nextPath={next ?? "/"} />;
  },
});
